import { useApi } from '@/shared/api/http';
import type {
  ICallbackCodeData,
  ICallbackData,
  ICallbackOrderData,
  ICallbackOrderResponse,
  IReadCallbackData,
} from '@/entities/callback/model/types/index';

export const useCallbackService = () => {
  const api = useApi();

  const callback = async (data: ICallbackData) => {
    return await api.post('callback', data);
  };

  const createCallbackOrder = async (data: ICallbackOrderData) => {
    return await api.post<ICallbackOrderResponse>('callback/order', data);
  };

  const getCallbackCode = async (
    data: ICallbackCodeData,
    bKeyToken: string | null = null,
  ) => {
    const options = bKeyToken ? { headers: { 'X-HASH-KEY': bKeyToken } } : undefined;

    return await api.post<{ message?: string }>('callback/code', data, options);
  };

  const readCallback = async (callbackId: number, data: IReadCallbackData) => {
    return await api.patch(`callback/${callbackId}/`, data);
  };

  return {
    callback,
    createCallbackOrder,
    getCallbackCode,
    readCallback,
  };
};
